import { useState, useEffect } from "preact/hooks";

export default function useBlogCardHeights() {
  const [cardContentHeight, setCardContentHeight] = useState(0);
  const [cardContentHeights, setCardContentHeights] = useState({});

  useEffect(() => {
    setCardContentHeight(Math.max(...Object.values(cardContentHeights), 0));
  }, [cardContentHeights]);

  const trackHeight = ({ id, height }) => {
    if (cardContentHeights[id] === height) return;

    setCardContentHeights((prev) => ({
      ...prev,
      [id]: height,
    }));
  };

  return [trackHeight, cardContentHeight];
}
